import { render, staticRenderFns } from "./CRUDTableCommonKPI.vue?vue&type=template&id=3a0b1608&scoped=true"
import script from "./CRUDTableCommonKPI.vue?vue&type=script&lang=js"
export * from "./CRUDTableCommonKPI.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableCommonKPI.vue?vue&type=style&index=0&id=3a0b1608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b1608",
  null
  
)

export default component.exports